import { AuthLayout } from '../../layout';
import { ResetPassForm } from '../../features/reset';
import { PAGES_ANALYTICS_TITLES } from '../../utils/enums';
import { PageHelmet } from '../../components';

const ResetPassPage = () => (
  <PageHelmet title={PAGES_ANALYTICS_TITLES.RESET_PASS}>
    <AuthLayout>
      <ResetPassForm />
    </AuthLayout>
  </PageHelmet>
);

export default ResetPassPage;
